var React = require('react');

function SingleSignOn (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M20.62 22.16h-4.09a1.6 1.6 0 0 1-1.58-1.6v-4.08c0-.87.7-1.59 1.58-1.59h4.09c.87 0 1.59.72 1.59 1.6v4.08a1.6 1.6 0 0 1-1.59 1.59zm-4.09-6.2c-.29 0-.53.23-.53.52v4.09c0 .29.24.53.53.53h4.09c.29 0 .53-.24.53-.53v-4.09c0-.29-.24-.53-.53-.53h-4.09z","key":0}),React.createElement("path",{"d":"M19 20.2h-.56v-2.65l-.81.28v-.47l1.29-.48h.07v3.33z","key":1}),React.createElement("g",{"key":2},[React.createElement("path",{"d":"M13.98 17.06h.96v2.02h-.96zM3.9 6.97h14.12v7.93h2.02V4.96c0-1.11-.9-2.02-2.02-2.02H3.9c-1.12 0-2.01.9-2.01 2.02v12.1c0 1.11.9 2.02 2.01 2.02h4.04v-2.02H3.9V6.97z","key":0}),React.createElement("path",{"d":"M10.96 9l-4.04 4.03h3.03v6.05h2.02v-6.05h3.02z","key":1})])]);
}

SingleSignOn.displayName = "SingleSignOn";

SingleSignOn.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = SingleSignOn;

SingleSignOn.default = SingleSignOn;



//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/SingleSignOn.svg
// module id = 652
// module chunks = 168707334958949